import { Translate } from "@/app/application/Translate";
import { Box } from "@mui/material";

export const ShiftTourSteps = [
	{
		selector: '[data-tour="shift-page"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.Shift.Welcome">
					Welcome to Shift — log events, view handovers, track out-of-service
					items, and search shift history.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="shift-tabs"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.Shift.Tabs">
					Switch between Shift Log, Handover, Out of Service, and Search. Use
					Filters to refine results.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="shift-content"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.Shift.Content">
					View and manage shift events. Click a row to view details, or use the
					toolbar to add events and adjust filters.
				</Translate>
			</Box>
		),
	},
];
